
import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
import { CardHeader, CardTitle } from '@/components/ui/card';

interface VitalScoreHeaderProps {
  totalScore: number;
  scoreText: string;
}

const VitalScoreHeader: React.FC<VitalScoreHeaderProps> = ({ totalScore, scoreText }) => {
  return (
    <>
      <CardHeader className="relative pb-2" style={{ zIndex: 1 }}>
        <CardTitle className="text-2xl flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Activity className="h-5 w-5 text-purple-600" />
            <span className="bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
              Vital Score
            </span>
          </div>
          <motion.div 
            className="flex items-center gap-1"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <motion.div 
              className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              {totalScore}
            </motion.div>
            <span className="text-xs text-gray-500">/100</span>
          </motion.div>
        </CardTitle>
      </CardHeader>
      <div className="text-sm font-medium text-center mb-2 bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
        {scoreText}
      </div>
    </>
  );
};

export default VitalScoreHeader;
